import styled from 'styled-components';

const StaffContainer = styled.section`
	text-align: center;
	${props => props.theme.breakpoints.up('xs')} {
		background-image: linear-gradient(338deg, #ffffff 13%, #eaeaea 65%);
		padding: 8% 8% 15% 8%;
	}
	${props => props.theme.breakpoints.up('sm')} {
		background-image: linear-gradient(305deg, #ffffff 28%, #eaeaea 50%);
		padding: 5% 0% 5% 0%;
	}
`;

export default StaffContainer;
